import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Grid, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Navbar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import { faqs } from '../../constants/Ajuda/perguntas';
import { Banner, BannerText, BannerLogo } from '../../styles/Banner';
import { faqsEstacio } from '../../constants/Ajuda/perguntasEstacio';
import useUTMParams from '../../hooks/useUTMParams';
const PerguntasFrequentes = () => {
    const [busca, setBusca] = useState('');

    const { utmSource } = useUTMParams();
    const isClubeDoAluno = utmSource === 'clube-do-aluno';

    const faqsBase = isClubeDoAluno ? faqsEstacio : faqs;

    const faqsFiltrados = faqsBase.filter(faq =>
        faq.pergunta.toLowerCase().includes(busca.toLowerCase()) ||
        faq.resposta.toLowerCase().includes(busca.toLowerCase())
    );
        return (
            <>  
                <Navbar/>
                <div>
                    <Banner>
                        <BannerText>
                        <p>
                            <a href="https://www.meucupom.com/" target='_blank' rel="noreferrer">Home</a> &gt; Ajuda &gt; Perguntas Frequentes
                        </p>
                        <Typography variant='h2'
                        >Como podemos ajudar?</Typography>

                        <TextField
                            placeholder="Pesquise sua dúvida..."
                            variant="outlined"
                            size="medium"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            sx={{
                                mt: 2,
                                backgroundColor: "#fff",
                                borderRadius: "50px",
                                width: "100%",
                                maxWidth: {
                                    xs: 300, 
                                    sm: 400, 
                                    md: 600, 
                                },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "transparent" },
                                    "&:hover fieldset": { borderColor: "#ffcc00" },
                                    "&.Mui-focused fieldset": { borderColor: "#ffcc00" }
                                }
                            }}
                            
                        />
                        <Link component={RouterLink} to="/ajuda/como-utilizar-um-cupom" underline="hover" 
                        sx={{
                            display: 'block',
                            color: 'white',
                            marginTop: '20px',
                            textTransform: 'uppercase',
                            marginLeft: '6px',
                        }}
                        >
                            Como utilizar um Cupom?
                        </Link>
                        </BannerText>
                        <BannerLogo>
                            <img 
                                src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png" 
                                alt="MeuCupom Logo" 
                            />
                        </BannerLogo>
                    </Banner>
                    <Container maxWidth="lg" sx={{ py: 4 }}>
                        <Typography 
                        variant="h4" 
                        sx={{
                            marginBottom: '3rem',
                            fontSize: { xs: '1.8rem', sm: '2rem', md: '2.5rem' } 
                        }}>
                        Perguntas Frequentes
                        </Typography>
                        <Grid container spacing={2}>
                        <Grid item xs={12}>
                        {faqsFiltrados.length > 0 ? (
                            faqsFiltrados.map((faq, index) => (
                                <Accordion key={index}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index}-content`}
                                    id={`panel${index}-header`}
                                    sx={{
                                    minHeight: 80,
                                    '& .MuiAccordionSummary-content': {
                                        margin: '20px 0',
                                    },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>{faq.pergunta}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>{faq.resposta}</Typography>
                                </AccordionDetails>
                                </Accordion>
                            ))
                            ) : (
                            <Typography variant="body1">Nenhuma pergunta encontrada.</Typography>
                        )}
                            
                        </Grid>
                        </Grid>
                    </Container>
                </div>
                <Footer/>
            </>
        );
};
export default PerguntasFrequentes;